export const UPDATE_BID_PROFILE_MANAGEMENT = 'UPDATE_BID_PROFILE_MANAGEMENT';
export const RESET_BID_PROFILE_MANAGEMENT = 'RESET_BID_PROFILE_MANAGEMENT';
export const UPDATE_EMPLOYEE_BID_SELECTION = 'UPDATE_EMPLOYEE_BID_SELECTION';
export const UPDATE_EMPLOYEE_SUBMISSION_STATUS = 'UPDATE_EMPLOYEE_SUBMISSION_STATUS';
